import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductsService } from '../../services/products.service';
import { Product } from '../../models/product.model';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ProductField } from '../../models/product-field.model';
import { NavigateService } from '../../services/navigate.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {
  code: string;
  product: Product;
  productForm: FormGroup;
  constructor(
    private activatedRoute: ActivatedRoute,
    private productService: ProductsService,
    private fb: FormBuilder,
    public navigate: NavigateService,
    private router: Router
  ) {
    this.createForm();
  }

  private createForm() {
    this.productForm = this.fb.group({
      productDescription: '',
      status: '',
      sort: 0,
      headerImage: '',
      legalReference: '',
      isPrintable: false,
      fields: this.fb.array([]),
    });
  }

  private rebuildForm() {
    this.productForm.reset({
      productDescription: this.product.productDescription,
      status: this.product.status,
      sort: this.product.sort,
        headerImage: this.product.headerImage,
        isPrintable: this.product.isPrintable,
      legalReference: this.product.legalReference
    });
    this.setFields(this.product.fields);
  }

  get fields(): FormArray {
    return this.productForm.get('fields') as FormArray;
  }

  private setFields(fields: ProductField[]) {
    this.productForm.setControl('fields', this.fb.array(fields.map(f => this.fb.group(f))));
  }

  private prepareSaveProduct(): Product {
    const formModel = this.productForm.value;

    const fieldsDeepCopy: ProductField[] = formModel.fields.map(
      (p: ProductField) => Object.assign({}, p)
    );

    const saveProduct: Product = {
      productCode : this.product.productCode,
      productDescription: formModel.productDescription as string,
      status: formModel.status as string,
      sort: formModel.sort as number,
      headerImage: formModel.headerImage as string,
      legalReference: formModel.legalReference as string,
      fields: fieldsDeepCopy,
      isPrintable: formModel.isPrintable as boolean
    };
    return saveProduct;
  }

  ngOnInit() {
    this.code = this.activatedRoute.snapshot.paramMap.get('code');
    this.productService
      .getProduct(this.code)
      .subscribe(val => {
        this.product = val;
        this.rebuildForm();
      });
  }

  addField() {
    this.fields.push(this.fb.group(new ProductField('', '', 1, false, '')));
  }

  spliceField(idx: number) {
    this.fields.removeAt(idx);
  }

  onSubmit() {
    this.productService.saveProduct(this.prepareSaveProduct()).subscribe(v => {
      this.router.navigateByUrl('/administrador/productos');
    });
  }
  revert() {
    this.rebuildForm();
  }
}
